// extracted by mini-css-extract-plugin
export default {"backButton":"BackButton_backButton__lB0Bj","backIcon":"BackButton_backIcon__43KQM"};